module.exports = __webpack_public_path__ + "media/images/appnexus_small_logo-1a080c426a438085c1efacff8519aab2.png";